/**
 *  @since: 2020-05-19
 *  @author: tams_dev1
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtServerProfileUrl: '/api/op/as/protect-mail/profiles',
  txtServerProfileCommitUrl: '/api/op/as-protect-mail-profiles',
  // 선택한 row 데이터
  rowSelectItems: {},
  rowSelectItemsSubTable: {},
  getServerProfileData: [],
  getServerListData: []
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.rowSelectItemsSubTable = {}
    state.getServerProfileData = []
    state.getServerListData = []
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  setRowSelectItemsSubTable: (state, data) => {
    state.rowSelectItemsSubTable = _.cloneDeep(data)
  },
  subTableHeaderMutation: (state, data) => {
    state.getServerListData = _.map(state.getServerListData, (item) => {
      item.smtp_mail_relay_use = data
      return item
    })
  },
  getServerProfileDataAction: (state, data) => {
    state.getServerProfileData = _.cloneDeep(data)
  },
  getServerListDataAction: (state, data) => {
    state.getServerListData = _.cloneDeep(data)
  },
  addServerProfileDataAction: (state, data) => {
    state.getServerProfileData.push(data)
  },
  editServerProfileDataAction: (state, data) => {
    state.getServerProfileData = _.map(state.getServerProfileData, (item) => {
      if (item.smtp_mail_relay_list_id === data.smtp_mail_relay_list_id) {
        item.smtp_mail_relay_list_uname = _.cloneDeep(data.smtp_mail_relay_list_uname)
        item.smtp_mail_relay_list_desc = _.cloneDeep(data.smtp_mail_relay_list_desc)
      }
      return item
    })
  },
  addSubTable: (state, data) => {
    state.getServerListData.push(data)
  },
  editSubTable: (state, data) => {
    state.resultServerListData = data
    state.getServerListData = _.map(state.getServerListData, (item) => {
      if (item.smtp_mail_relay_id === data.smtp_mail_relay_id) {
        item = _.cloneDeep(data)
      }
      return item
    })
  }
}

export const actions = {
  // 보호메일 서버목록 조회
  async getServerProfileDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtServerProfileUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getServerProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 보호메일 서버 상세조회
  async getServerListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items`)
      return resultFactory(commit, {length: null, data: data, action: 'getServerListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 보호메일 서버목록 추가
  async addServerProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtServerProfileUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addServerProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 보호메일 서버목록 수정
  async editServerProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editServerProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 보호메일 서버목록 삭제
  async delServerProfileDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'smtp_mail_relay_list_id': item.smtp_mail_relay_list_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtServerProfileUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 하단 테이블 보호메일서버 추가
  async addSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 하단 테이블 보호메일서버 수정
  async editSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items/${state.rowSelectItemsSubTable[0].smtp_mail_relay_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 하단 테이블 보호메일서버 일괄수정
  async editAllSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 하단 테이블 보호메일서버 삭제
  async delSubTable ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItemsSubTable.length > 1) {
      isMulty = true
      state.rowSelectItemsSubTable.forEach((item) => {
        idList.push({'smtp_mail_relay_list_id': state.rowSelectItems[0].smtp_mail_relay_list_id, 'smtp_mail_relay_id': item.smtp_mail_relay_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtServerProfileUrl}/${state.rowSelectItems[0].smtp_mail_relay_list_id}/items/${state.rowSelectItemsSubTable[0].smtp_mail_relay_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 보호메일서버 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtServerProfileCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
